module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "msgDstail"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_vm._v("消息详情\n        "), _c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.msgDstail(0)
      }
    }
  }, [_vm._v("保存")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "160px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "消息状态：",
      "required": ""
    }
  }, [_c('el-input', {
    staticClass: "myInput",
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.form.msgStatus),
      callback: function($$v) {
        _vm.$set(_vm.form, "msgStatus", $$v)
      },
      expression: "form.msgStatus"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "消息用途：",
      "required": ""
    }
  }, [_c('el-input', {
    staticClass: "myInput",
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.form.msgPurpose),
      callback: function($$v) {
        _vm.$set(_vm.form, "msgPurpose", $$v)
      },
      expression: "form.msgPurpose"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "消息类型:",
      "required": ""
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "40%"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.form.msgType),
      callback: function($$v) {
        _vm.$set(_vm.form, "msgType", $$v)
      },
      expression: "form.msgType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "类型一",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "类型二",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "类型三",
      "value": "3"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "推送范围:",
      "required": ""
    }
  }, [_c('el-input', {
    staticClass: "msgContent",
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 3
      },
      "disabled": ""
    },
    model: {
      value: (_vm.form.pushContentList),
      callback: function($$v) {
        _vm.$set(_vm.form, "pushContentList", $$v)
      },
      expression: "form.pushContentList"
    }
  })], 1), _vm._v(" "), (_vm.form.coverPic) ? _c('el-form-item', {
    attrs: {
      "label": "封面图标:",
      "required": ""
    }
  }, [_c('div', [_c('img', {
    staticClass: "logoImg",
    attrs: {
      "src": _vm.form.coverPic
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.form.msgType != '3') ? _c('el-form-item', {
    attrs: {
      "label": "标题：",
      "required": ""
    }
  }, [_c('el-input', {
    staticClass: "myInput",
    attrs: {
      "placeholder": "",
      "disabled": ""
    },
    model: {
      value: (_vm.form.msgHeadline),
      callback: function($$v) {
        _vm.$set(_vm.form, "msgHeadline", $$v)
      },
      expression: "form.msgHeadline"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.form.msgType == '1') ? _c('el-form-item', {
    attrs: {
      "label": "副标题：",
      "required": ""
    }
  }, [_c('el-input', {
    staticClass: "myInput",
    attrs: {
      "placeholder": "",
      "disabled": ""
    },
    model: {
      value: (_vm.form.msgSubheadline),
      callback: function($$v) {
        _vm.$set(_vm.form, "msgSubheadline", $$v)
      },
      expression: "form.msgSubheadline"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.form.msgType != '1') ? _c('el-form-item', {
    attrs: {
      "label": "消息内容：",
      "required": ""
    }
  }, [_c('el-input', {
    staticClass: "msgContent",
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 3
      },
      "placeholder": "请输入消息内容",
      "disabled": ""
    },
    model: {
      value: (_vm.form.msgContent),
      callback: function($$v) {
        _vm.$set(_vm.form, "msgContent", $$v)
      },
      expression: "form.msgContent"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.form.msgType == '1') ? _c('el-form-item', {
    attrs: {
      "label": "跳转h5地址：",
      "required": ""
    }
  }, [_c('el-input', {
    staticClass: "myInput",
    attrs: {
      "placeholder": "",
      "disabled": ""
    },
    model: {
      value: (_vm.form.redirectH5Url),
      callback: function($$v) {
        _vm.$set(_vm.form, "redirectH5Url", $$v)
      },
      expression: "form.redirectH5Url"
    }
  })], 1) : _vm._e()], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2151cd1c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/secretary/message/msgDetail.vue
// module id = 966
// module chunks = 0